module.exports = __webpack_public_path__ + "img/Logo-32.94a16b29.svg";